"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.pan = pan;
exports.zoomByDelta = zoomByDelta;

var _Object = _interopRequireDefault(require("../Object.js"));

var _Property = _interopRequireDefault(require("./Property.js"));

var _easing = require("../easing.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/Interaction
 */


/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active', Return>} InteractionOnSignature
 */

/**
 * Object literal with config options for interactions.
 * @typedef {Object} InteractionOptions
 * @property {function(import("../MapBrowserEvent.js").default):boolean} handleEvent
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. If the function returns a falsy value, propagation of
 * the event to other interactions in the map's interactions chain will be
 * prevented (this includes functions with no explicit return). The interactions
 * are traversed in reverse order of the interactions collection of the map.
 */

/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * User actions that change the state of the map. Some are similar to controls,
 * but are not associated with a DOM element.
 * For example, {@link module:ol/interaction/KeyboardZoom~KeyboardZoom} is
 * functionally the same as {@link module:ol/control/Zoom~Zoom}, but triggered
 * by a keyboard event not a button element event.
 * Although interactions do not have a DOM element, some of them do render
 * vectors and so are visible on the screen.
 * @api
 */
var Interaction =
/** @class */
function (_super) {
  __extends(Interaction, _super);
  /**
   * @param {InteractionOptions} [opt_options] Options.
   */


  function Interaction(opt_options) {
    var _this = _super.call(this) || this;
    /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */


    _this.on;
    /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */

    _this.once;
    /***
     * @type {InteractionOnSignature<void>}
     */

    _this.un;

    if (opt_options && opt_options.handleEvent) {
      _this.handleEvent = opt_options.handleEvent;
    }
    /**
     * @private
     * @type {import("../PluggableMap.js").default|null}
     */


    _this.map_ = null;

    _this.setActive(true);

    return _this;
  }
  /**
   * Return whether the interaction is currently active.
   * @return {boolean} `true` if the interaction is active, `false` otherwise.
   * @observable
   * @api
   */


  Interaction.prototype.getActive = function () {
    return (
      /** @type {boolean} */
      this.get(_Property["default"].ACTIVE)
    );
  };
  /**
   * Get the map associated with this interaction.
   * @return {import("../PluggableMap.js").default|null} Map.
   * @api
   */


  Interaction.prototype.getMap = function () {
    return this.map_;
  };
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event}.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */


  Interaction.prototype.handleEvent = function (mapBrowserEvent) {
    return true;
  };
  /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */


  Interaction.prototype.setActive = function (active) {
    this.set(_Property["default"].ACTIVE, active);
  };
  /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../PluggableMap.js").default|null} map Map.
   */


  Interaction.prototype.setMap = function (map) {
    this.map_ = map;
  };

  return Interaction;
}(_Object["default"]);
/**
 * @param {import("../View.js").default} view View.
 * @param {import("../coordinate.js").Coordinate} delta Delta.
 * @param {number} [opt_duration] Duration.
 */


function pan(view, delta, opt_duration) {
  var currentCenter = view.getCenterInternal();

  if (currentCenter) {
    var center = [currentCenter[0] + delta[0], currentCenter[1] + delta[1]];
    view.animateInternal({
      duration: opt_duration !== undefined ? opt_duration : 250,
      easing: _easing.linear,
      center: view.getConstrainedCenter(center)
    });
  }
}
/**
 * @param {import("../View.js").default} view View.
 * @param {number} delta Delta from previous zoom level.
 * @param {import("../coordinate.js").Coordinate} [opt_anchor] Anchor coordinate in the user projection.
 * @param {number} [opt_duration] Duration.
 */


function zoomByDelta(view, delta, opt_anchor, opt_duration) {
  var currentZoom = view.getZoom();

  if (currentZoom === undefined) {
    return;
  }

  var newZoom = view.getConstrainedZoom(currentZoom + delta);
  var newResolution = view.getResolutionForZoom(newZoom);

  if (view.getAnimating()) {
    view.cancelAnimations();
  }

  view.animate({
    resolution: newResolution,
    anchor: opt_anchor,
    duration: opt_duration !== undefined ? opt_duration : 250,
    easing: _easing.easeOut
  });
}

var _default = Interaction;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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